import { render, staticRenderFns } from "./TravelDetail.vue?vue&type=template&id=7c60e6ca&scoped=true&"
import script from "./TravelDetail.vue?vue&type=script&lang=js&"
export * from "./TravelDetail.vue?vue&type=script&lang=js&"
import style0 from "./TravelDetail.vue?vue&type=style&index=0&lang=less&"
import style1 from "./TravelDetail.vue?vue&type=style&index=1&lang=less&"
import style2 from "./TravelDetail.vue?vue&type=style&index=2&id=7c60e6ca&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c60e6ca",
  null
  
)

export default component.exports